
import React from 'react'
import PortalModal from '../portal_modal';
import PortalActions from '../portal_actions';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import './portabilityBanner.scss';

export const PortabilityBannerComponent: React.FC = () => {
    const {open, close, openModal, closeModal} = PortalActions()

    const savedCount = useTypedSelector(state => state.projectsCount.saved)
    const savedSubCount = useTypedSelector(state => state.projectsCount.savedSubCounts)

    const getMobileProjectCount = (countByProduct) => {
        let mobileProjectsCount = 0
        if(countByProduct){
            for( var product in countByProduct ) {
                if( countByProduct.hasOwnProperty( product ) ) {
                    mobileProjectsCount += parseInt( countByProduct[product] );
                }
            }
        }
        return mobileProjectsCount;
    }
    const showPortableBanner = () => {
        const subCounts = savedSubCount
        {/** @ts-ignore */}
        if(photoOrg.config.projects_portability && savedCount && subCounts){
            const mobileCount = (subCounts["sf-mobile-ios"] ? getMobileProjectCount(subCounts["sf-mobile-ios"]) : 0) +
                                                    (subCounts["sf-mobile-android"] ? getMobileProjectCount(subCounts["sf-mobile-android"]) : 0);

            if(mobileCount > 0){
                return true;
            }
            return false;
        }
        return false
    }
    return showPortableBanner() ? (<div className="app_hint_text_sec row">
    {open? (
        <> 
            {/** @ts-ignore */}
            <PortalModal overlayContent={{header:(photoOrg.translations.projects["projects"]["mobile_projects"]),body:(photoOrg.translations.projects["projects"]["port_project_help1"]), bodyTxt2: (photoOrg.translations.projects["projects"]["port_project_help3"])}}
            isOpen={open}
            onClose={closeModal}
            />
        </>) : null
    }
    <div className="app_hint_text">
    {/** @ts-ignore */}
    <span className="new_text">{photoOrg.translations.projects["projects"]["new_txt"]}</span>
    {/** @ts-ignore */}
    {photoOrg.translations.projects["projects"]["mob_app_hint_txt"]}
    {/** @ts-ignore */}
    <a href="javascript:void(0)" onClick={openModal} className="icon-icon_device_mobile portable-more-info">{photoOrg.translations.projects["projects"]["fav_more_info"]}</a>
    </div>
    </div>): null;
}

export default PortabilityBannerComponent;

// const mapStateToProps = ({projectsCount}) => {
//     return {
//         savedCount : projectsCount.saved,
//         savedSubCount : projectsCount.savedSubCounts
//     }
// }

//export default connect(mapStateToProps,null)(PortabilityBannerComponent)

